import type { AnalyticsTransport, TimestampedAnalyticsEvent } from '@thinkalpha/ui-ioc/core/types/AnalyticsService';
import type { DatadogService } from '@thinkalpha/ui-ioc/core/types/DatadogService';
import type { UserDetails } from '@thinkalpha/ui-types/types/user';
import { inject, injectable } from 'inversify';

@injectable()
export class DatadogWebTransport implements AnalyticsTransport {
    constructor(@inject('DatadogService') private datadogService: DatadogService) {}

    async sendEvents(events: TimestampedAnalyticsEvent[]): Promise<void> {
        for (const event of events) {
            if (event.type === 'feature_flag') {
                // Skip feature flag events - they're handled elsewhere
                continue;
            }

            // Submit all other event types directly using the event type as action name
            this.datadogService.submitActionToDatadog(event.type, event);
        }
    }

    setUser(user: UserDetails): void {
        this.datadogService.setUserDetails(user);
    }

    clearUser(): void {
        this.datadogService.setUserDetails(undefined);
    }
}
